/**
 * QueryService shared constants
 */

/**
 * Maps cluster size to executor count
 */
export const CLUSTER_SIZE_TO_EXECUTORS: Record<string, number> = {
  xs: 1,
  s: 2,
  m: 4,
  l: 8,
  xl: 16,
  xxl: 32,
};

/**
 * Route paths for QueryService pages
 */
export const QUERY_SERVICE_ROUTES = {
  list: '/queryservices',
  create: '/queryservices/create',
  detail: (name: string) => `/queryservices/detail?name=${name}`,
  edit: (name: string) => `/queryservices/edit?name=${name}`,
} as const;

/**
 * Page titles and descriptions
 */
export const QUERY_SERVICE_PAGE_META = {
  list: {
    title: 'Clusters',
    description: 'Manage your compute clusters',
  },
  create: {
    title: 'Create Cluster',
    description: 'Configure a new compute cluster',
  },
  edit: {
    title: (name: string) => name,
    description: 'Edit cluster',
  },
  detail: {
    title: (name: string) => name,
    description: 'Cluster details',
  },
} as const;
